// extracted by mini-css-extract-plugin
module.exports = {"blog-image":"styles_blog-image__3fTaB","thumbnail-image":"styles_thumbnail-image__2meeV","topic-channel-image":"styles_topic-channel-image__30W5P"};